const BASE_URL = '/api'

// 上传图片
export const uploadImage = async (file) => {
  const formData = new FormData()
  formData.append('file', file)
  
  const response = await fetch(`${BASE_URL}/upload`, {
    method: 'POST',
    body: formData
  })
  return response.json()
}

// 获取客户案例
export const getCaseList = async (params = {}) => {
  const query = new URLSearchParams(params).toString()
  const response = await fetch(`${BASE_URL}/caseList?${query}`)
  return response.json()
}

// 添加客户案例
export const addCase = async (data) => {
  const response = await fetch(`${BASE_URL}/caseList`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  return response.json()
}

// 更新客户案例
export const updateCase = async (id, data) => {
  const response = await fetch(`${BASE_URL}/caseList/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  return response.json()
}

// 删除客户案例
export const deleteCase = async (id) => {
  const response = await fetch(`${BASE_URL}/caseList/${id}`, {
    method: 'DELETE'
  })
  return response.json()
}

// 获取常见问题
export const getFaqList = async (params = {}) => {
  const query = new URLSearchParams(params).toString()
  const response = await fetch(`${BASE_URL}/faqList?${query}`)
  return response.json()
}

// 添加常见问题
export const addFaq = async (data) => {
  const response = await fetch(`${BASE_URL}/faqList`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  return response.json()
}

// 更新常见问题
export const updateFaq = async (id, data) => {
  const response = await fetch(`${BASE_URL}/faqList/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  return response.json()
}

// 删除常见问题
export const deleteFaq = async (id) => {
  const response = await fetch(`${BASE_URL}/faqList/${id}`, {
    method: 'DELETE'
  })
  return response.json()
}

// 获取荣誉资质
export const getHonorList = async (params = {}) => {
  const query = new URLSearchParams(params).toString()
  const response = await fetch(`${BASE_URL}/honorList?${query}`)
  return response.json()
}

// 添加荣誉资质
export const addHonor = async (data) => {
  const response = await fetch(`${BASE_URL}/honorList`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  return response.json()
}

// 更新荣誉资质
export const updateHonor = async (id, data) => {
  const response = await fetch(`${BASE_URL}/honorList/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  return response.json()
}

// 删除荣誉资质
export const deleteHonor = async (id) => {
  const response = await fetch(`${BASE_URL}/honorList/${id}`, {
    method: 'DELETE'
  })
  return response.json()
}

// 获取核心优势
export const getAdvantages = async () => {
  const response = await fetch(`${BASE_URL}/advantages`)
  return response.json()
}

// 更新核心优势
export const updateAdvantages = async (data) => {
  // 由于 advantages 是数组，需要遍历更新
  const results = []
  for (const item of data) {
    const response = await fetch(`${BASE_URL}/advantages/${item.id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(item)
    })
    results.push(response.json())
  }
  return Promise.all(results)
}

// 获取咨询记录
export const getSubmissions = async () => {
  const response = await fetch(`${BASE_URL}/submissions`)
  const data = await response.json()
  // 按提交时间降序排列
  return data.sort((a, b) => {
    const timeA = new Date(a.createdAt || a.createAt || 0).getTime()
    const timeB = new Date(b.createdAt || b.createAt || 0).getTime()
    return timeB - timeA
  })
}

// 提交咨询表单
export const submitForm = async (data) => {
  const response = await fetch(`${BASE_URL}/submissions`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  return response.json()
}

// 删除咨询记录
export const deleteSubmission = async (id) => {
  const response = await fetch(`${BASE_URL}/submissions/${id}`, {
    method: 'DELETE'
  })
  return response.json()
}

// 清空所有咨询记录
export const clearSubmissions = async () => {
  const response = await fetch(`${BASE_URL}/submissions`, {
    method: 'DELETE'
  })
  return response.json()
}

// 获取企业介绍
export const getAbout = async () => {
  const response = await fetch(`${BASE_URL}/about`)
  return response.json()
}

// 更新企业介绍
export const updateAbout = async (data) => {
  const response = await fetch(`${BASE_URL}/about`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }
  return response.json()
}

// 获取服务列表
export const getServices = async () => {
  const response = await fetch(`${BASE_URL}/services`)
  return response.json()
}

// 添加服务
export const addService = async (data) => {
  const response = await fetch(`${BASE_URL}/services`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  return response.json()
}

// 更新服务
export const updateService = async (id, data) => {
  const response = await fetch(`${BASE_URL}/services/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  return response.json()
}

// 删除服务
export const deleteService = async (id) => {
  const response = await fetch(`${BASE_URL}/services/${id}`, {
    method: 'DELETE'
  })
  return response.json()
}
